var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "import-from-image",
        title: "Import image",
        centered: "",
        size: "lg",
      },
      on: { ok: _vm.handleOkBtn, hide: _vm.handleModalClose },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c("b-button", { on: { click: cancel } }, [
                    _vm._v("\n        Cancel\n      "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mx-1" }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.importAvailable || _vm.isImporting,
                      },
                      on: { click: _vm.handleOkBtn },
                    },
                    [
                      _vm.isImporting
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v("\n        OK\n      "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c("Multiselect", {
        staticClass: "mb-3",
        attrs: {
          options: _vm.layouts,
          loading: _vm.isLoading,
          searchable: "",
          multiple: "",
          "custom-label": _vm.customLabel,
          "track-by": "id",
          placeholder: "Add to existing layout (optional)",
        },
        on: {
          "search-change": _vm.searchCustomerLayouts,
          select: (option) => (_vm.selectedLayout = [option]),
        },
        scopedSlots: _vm._u(
          [
            _vm.layouts.length < _vm.layoutsTotalCount
              ? {
                  key: "afterList",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "load-more-btn" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.isLoading,
                                variant: "outline-primary",
                              },
                              on: { click: _vm.getCustomerLayouts },
                            },
                            [_vm._v("\n          Load More\n        ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.selectedLayout,
          callback: function ($$v) {
            _vm.selectedLayout = $$v
          },
          expression: "selectedLayout",
        },
      }),
      _vm._v(" "),
      _c("b-form-radio-group", {
        attrs: { name: "select-strategy", options: _vm.options },
        model: {
          value: _vm.selectedStrategy,
          callback: function ($$v) {
            _vm.selectedStrategy = $$v
          },
          expression: "selectedStrategy",
        },
      }),
      _vm._v(" "),
      _vm.selectedStrategy === _vm.IMPORT_INTO_EXISTS_TEMPLATE_STRATEGY
        ? _c("SelectTemplateBanner", {
            staticClass: "mt-3",
            attrs: { customers: _vm.customers },
            model: {
              value: _vm.selectedTemplates,
              callback: function ($$v) {
                _vm.selectedTemplates = $$v
              },
              expression: "selectedTemplates",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.selectedLayout.length
        ? _c(
            "b-form-group",
            { staticClass: "mt-3", attrs: { label: "New layout name" } },
            [
              _c("b-form-input", {
                model: {
                  value: _vm.layoutName,
                  callback: function ($$v) {
                    _vm.layoutName = $$v
                  },
                  expression: "layoutName",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-group",
        { staticClass: "mt-3" },
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { switch: "" },
              model: {
                value: _vm.createLayers,
                callback: function ($$v) {
                  _vm.createLayers = $$v
                },
                expression: "createLayers",
              },
            },
            [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("Create Layers"),
              ]),
              _vm._v(" "),
              _c("small", { staticClass: "text-muted d-block" }, [
                _vm._v(
                  "\n        Use AI to segment the image into separate layers (products, background, text)\n      "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.createLayers
        ? _c(
            "div",
            { staticClass: "advanced-section" },
            [
              _c(
                "button",
                {
                  staticClass: "advanced-toggle",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.isAdvancedOpen,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.isAdvancedOpen = !_vm.isAdvancedOpen
                    },
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "advanced-toggle__chevron",
                    class: { "is-open": _vm.isAdvancedOpen },
                    attrs: { icon: "chevron-down" },
                  }),
                  _vm._v("\n      Advanced\n    "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  model: {
                    value: _vm.isAdvancedOpen,
                    callback: function ($$v) {
                      _vm.isAdvancedOpen = $$v
                    },
                    expression: "isAdvancedOpen",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "advanced-option" },
                    [
                      _c("ResizeSizeInput", {
                        attrs: { label: "Resize Sizes" },
                        model: {
                          value: _vm.resizeSizes,
                          callback: function ($$v) {
                            _vm.resizeSizes = $$v
                          },
                          expression: "resizeSizes",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }